{
  "title": "Zezwolić na dostęp do Twojej lokalizacji?",
  "body": "Zezwalając na dostęp do Twojej lokalizacji, możemy upewnić się, że dotarłeś do obiektu w celu zameldowania",
  "disagree": "Nie zgadzam się",
  "agree": "Zgadzam się"
}
